/**
 * The admin menu: a few groups, each a page with tabs. One list drives the sidebar, the routes
 * and the redirects from the old flat URLs (bookmarks, OAuth return links, chat-app messages).
 */
export interface AdminTab {
  /** Path segment under the group. */
  path: string;
  label: string;
}
export interface AdminGroup {
  /** Path segment under /admin. */
  base: string;
  label: string;
  /** A single page has no tab bar. */
  tabs: AdminTab[];
}

export const ADMIN_GROUPS: AdminGroup[] = [
  {
    base: "people",
    label: "People & access",
    tabs: [
      { path: "users", label: "Users" },
      { path: "groups", label: "Groups & permissions" },
      { path: "sso", label: "Sign-in (SSO)" },
      { path: "audit", label: "Audit log" },
    ],
  },
  {
    base: "assistants",
    label: "Assistants",
    tabs: [
      { path: "list", label: "Assistants" },
      { path: "models", label: "Models & providers" },
      { path: "usage", label: "Usage" },
    ],
  },
  {
    base: "knowledge",
    label: "Knowledge",
    tabs: [
      { path: "memory", label: "Memory" },
      { path: "skills", label: "Skills" },
      { path: "sync", label: "Knowledge sync" },
    ],
  },
  {
    base: "integrations",
    label: "Integrations",
    tabs: [
      { path: "mcp", label: "MCP servers" },
      { path: "messaging", label: "Messaging" },
    ],
  },
  { base: "branding", label: "Branding", tabs: [] },
];

/** The flat URLs from before the grouping → where each page lives now. */
export const LEGACY_ADMIN_PATHS: Record<string, string> = {
  users: "people/users",
  groups: "people/groups",
  sso: "people/sso",
  audit: "people/audit",
  runtimes: "assistants/list",
  models: "assistants/models",
  usage: "assistants/usage",
  memory: "knowledge/memory",
  skills: "knowledge/skills",
  sync: "knowledge/sync",
  mcp: "integrations/mcp",
  messaging: "integrations/messaging",
};
